import { Chip } from '@rrexpress/core';

const ChipStatus = ({ status }: { status: string }) => {
  let label = 'Tidak Aktif';

  if (status === 'active') label = 'Aktif';
  else if (status === 'pending') label = 'Pending';

  return (
    <Chip
      label={label}
      backgroundColor={status === 'active' ? '#E6F7F4' : '#DFE0E9'}
      borderColor={status === 'active' ? '#E6F7F4' : '#DFE0E9'}
      color={status === 'active' ? '#006C5A' : '#888888'}
    />
  );
};

export default ChipStatus;
